import { Box, InputGroup, InputLeftElement, Input } from '@chakra-ui/react'
import { ChangeEvent, FC, useState } from 'react'
import { BsSearch } from 'react-icons/bs'

import useTools from '@hook/shared/use-tools'

import { ILayoutToolsSearcherProps } from '@base/@types/components/Layout/Tools'

const LayoutToolsSearcher: FC<ILayoutToolsSearcherProps> = ({
  onChange,
  query: lastQuery
}) => {
  const { isDisabled } = useTools()

  const [query, setQuery] = useState(lastQuery)

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    setQuery(value)
    onChange(value)
  }

  return (
    <Box w="240px" pl={2}>
      <InputGroup size="sm" borderColor="gray.200">
        <InputLeftElement pointerEvents="none">
          <BsSearch color="var(--chakra-colors-gray-400)" />
        </InputLeftElement>
        <Input
          placeholder="Buscar..."
          borderRadius="8px"
          pl={8}
          value={query}
          onChange={handleInputChange}
          isDisabled={isDisabled}
          _hover={{
            borderColor: 'yellow.400'
          }}
          _placeholder={{
            color: 'gray.400'
          }}
        />
      </InputGroup>
    </Box>
  )
}

export default LayoutToolsSearcher
